import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { AI_WEB_MODULE_CONFIG } from '../../../../ai';
import { GetUsageWalletUseCase, USAGE_API, USAGE_REPOSITORY, UsageApi, usageWebRepositoryProvider } from '../../../../user';
import { AI_CHAT_ACCOUNTING_SUBSCRIPTION_API, AIChatAccountingSubscriptionApi, aiChatAccountingSubscriptionRepositoryProvider } from '../../data';
import { AI_CHAT_ACCOUNTING_SUBSCRIPTION_REPOSITORY } from '../../core';
import { GET_AI_CHAT_ACCOUNTING_SUBSCRIPTION_USE_CASE, GET_AI_CHAT_USAGE_WALLET_USE_CASE } from '../../redux/ai-chat/ai-chat.action';
import { GetAIChatAccountingSubscriptionUseCase } from '../../core';
export var billingDataProviders = [{
  provide: USAGE_API,
  useFactory: function useFactory(config) {
    return new UsageApi(new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    }).toInstance());
  },
  inject: [AI_WEB_MODULE_CONFIG]
}, usageWebRepositoryProvider, {
  provide: AI_CHAT_ACCOUNTING_SUBSCRIPTION_API,
  useFactory: function useFactory(config) {
    var accountingAxiosInstance = config.accountingBaseUrl ? new AxiosInstanceBuilder().withBaseUrl(config.accountingBaseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    }).toInstance() : undefined;
    return new AIChatAccountingSubscriptionApi(accountingAxiosInstance);
  },
  inject: [AI_WEB_MODULE_CONFIG]
}, aiChatAccountingSubscriptionRepositoryProvider];
export var billingUseCaseProviders = [{
  provide: GET_AI_CHAT_USAGE_WALLET_USE_CASE,
  useFactory: function useFactory(usageRepository) {
    return new GetUsageWalletUseCase(usageRepository);
  },
  inject: [USAGE_REPOSITORY]
}, {
  provide: GET_AI_CHAT_ACCOUNTING_SUBSCRIPTION_USE_CASE,
  useFactory: function useFactory(accountingSubscriptionRepository) {
    return new GetAIChatAccountingSubscriptionUseCase(accountingSubscriptionRepository);
  },
  inject: [AI_CHAT_ACCOUNTING_SUBSCRIPTION_REPOSITORY]
}];